// 챔피언 이름표 화면 좌표 캐시: 반올림한 마지막 좌표를 기억해 바뀔 때만 DOM style을 쓴다(프레임 루프 무할당, PR #175 5차 리뷰 P2).
export class TagPosCache {
  private x = Number.NaN;
  private y = Number.NaN;
  /** 좌표가 마지막으로 쓴 값과 다르면 기록하고 true(= style을 써야 함). 같으면 false */
  update(x: number, y: number): boolean {
    if (x === this.x && y === this.y) return false;
    this.x = x; this.y = y;
    return true;
  }
}
